<template>
  <div class="component-form">
    <h1 class="form-title">Finalized Syllabus</h1>
    <p class="text mt-30">
      Please make the needed edits based on the feedback received on your Syllabus draft. When finished, please upload the document in PDF and Word format to
      the Portal, and click submit.
    </p>
    <FileUploader
      class="mt-20 inp-wrap big"
      text="Upload(PDF)"
      :acceptType="['PDF']"
      :value="value.file1"
      @input="handleInput($event, 'file1')"
      loadText="loading"
      :role="ROLES.SL"
    />
    <FileUploader
      class="mt-20 inp-wrap big"
      text="Upload(Word)"
      :acceptType="['DOC', 'DOCX']"
      :value="value.file3"
      @input="handleInput($event, 'file3')"
      loadText="loading"
      :role="ROLES.SL"
    />
    <p class="text mt-30">Upload merged reading material PDF</p>
    <FileUploader
      class="mt-20 inp-wrap big"
      text="Upload"
      :acceptType="['PDF']"
      :value="value.file2"
      @input="handleInput($event, 'file2')"
      loadText="loading"
      :role="ROLES.SL"
    />
    <Button class="btn-submit" @click="handleClickSubmit">Submit</Button>
  </div>
</template>
<script>
import ROLES from '../../../../utils/roles';
import { Button, FileUploader } from '../../../../components/form';
export default {
  name: 'FinalizedSyllabus',
  components: {
    Button,
    FileUploader
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {};
      }
    },
    originData: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    ROLES() {
      return ROLES;
    },
    currentSyllabus() {
      let ret = '';
      if (this.originData && this.originData.syllabus_draft) {
        let syllabusDraft = this.originData.syllabus_draft;
        if (syllabusDraft.link && syllabusDraft.link !== '') {
          ret = syllabusDraft.link;
        }
      }
      return ret;
    },
    showCheckWrap() {
      return this.currentSyllabus && this.currentSyllabus !== '';
    }
  },
  methods: {
    handleInput: function(value, name) {
      this.$emit('input', {
        ...this.value,
        [name]: value
      });
    },
    handleClickSubmit: function() {
      this.$emit('submit');
    },
    handleClickDownload: function() {
      this.$windowOpen(this.currentSyllabus);
    }
  }
};
</script>
